module.exports = __webpack_public_path__ + "static/ovuli2-8754a67c90ad5c1dd2a22ca5df1a240f.gif";